import { makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const UseDecisionAlertStyles = makeStyles((theme: ITheme) => ({
  alertStyle: {
    color: theme.palette.warning.main,
    fontSize: '1rem',
    padding: '1rem',
    border: `2px solid ${theme.palette.warning.main}`,
    marginBottom: '1rem',
  },
  yesButton: {
    '&.MuiButton-containedSizeLarge': {
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.white,
      marginRight: '1rem',
    },
  },
  noButton: {
    '&.MuiButton-sizeLarge': {
      color: theme.palette.warning.main,
      marginRight: '1rem',
      '&:hover': {
        backgroundColor: theme.palette.warning.veryLight,
      },
    },
  },
}));

export default UseDecisionAlertStyles;
